<ion-toolbar>
  <ion-grid class="ion-no-padding">
    <ion-row class="ion-padding-bottom">
      <ion-col size="4">
        <div class="white-logo"></div>
      </ion-col>
      <ion-col class="contact-us" size="4">
        <div>
          <a (click)="displayModal(contactUsLink)">
            <h3>{{ "commons.footer.contactUs" | translate }}</h3>
          </a>
        </div>
      </ion-col>
    </ion-row>
    <ion-row class="ion-padding-bottom">
      <ion-col size="8">
        <a class="footer-link-text" *ngFor="let link of links" (click)="displayModal(link)">{{ link.name }}</a>
      </ion-col>
      <ion-col size="4" class="ion-text-right copyright-text">
        <ion-label>{{ "commons.footer.copyright" | translate: { year: currentYear } }}</ion-label>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-toolbar>
<div class="version"> Version {{ appVersion }}</div>
